/**
 * 身份驗證攔截器
 * 負責為請求添加身份驗證標頭
 */
import { authRepository } from "@/infrastructure/authentication";

// 默認標頭
export const defaultHeaders = {
  "Content-Type": "application/json",
};

/**
 * 添加認證標頭
 * @param headers 原始標頭
 * @returns 添加了認證資訊的標頭
 */
export function withAuth(headers = {}): Record<string, string> {
  const token = authRepository.retrieveToken();
  if (token) {
    return {
      ...headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return headers as Record<string, string>;
}
